<template>
  <div id="app">
    <b-navbar toggleable="md">
      <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
      <b-navbar-brand to="/home"><img class="logo" src="./assets/logo-romeflex.png" alt="Romeflex Market Plaform"/></b-navbar-brand>
      <b-collapse is-nav id="nav_collapse">
        <b-navbar-nav>
          <b-nav-item v-if="$session.exists()" to="/home">Home</b-nav-item>
          <b-nav-item v-if="$session.exists() && $session.get('user').role==='admin'" to="/market-sessions">Market Sessions</b-nav-item>
          <b-nav-item v-if="$session.exists() && $session.get('user').role==='admin'" to="/settlement">Settlement</b-nav-item>
          <b-nav-item v-if="$session.exists() && $session.get('user').role==='admin'" to="/pods">Pods</b-nav-item>
          <b-nav-item v-if="$session.exists() && $session.get('user').role==='DSO'" to="/product">Asta a Termine</b-nav-item>
          <b-nav-item v-if="$session.exists() && $session.get('user').role==='DSO'" to="/meritOrderProducts">Risultati</b-nav-item>
        </b-navbar-nav>
        <b-navbar-nav class="ml-auto">
          <b-nav-item-dropdown  v-if="$session.exists()" right split>
            <template slot="button-content"><v-icon class="user-icon" name="user" scale="2"/><span class="user">{{$session.get('user').username}}</span></template>
            <b-dropdown-item href="#">Account</b-dropdown-item>
            <b-dropdown-item  v-on:click="doLogout()">Logout</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'app',
  methods: {
    doLogout () {
      this.$session.destroy()
      this.$router.push('/')
    }
  }
}
</script>

<style>
  body {
    height: 100%;
  /*  background: url("assets/background.jpg");*/
    background-size: cover;
  }
  .navbar {
    box-shadow: 0 0 5px #e3e3e3;
    margin-bottom: 20px;
  }
  .nav-link {
    text-transform: capitalize;
  }
  .bg-dark {
    background-color: #34495e !important;
  }
  .navbar-brand img {
    height: 60px;
    margin-right: 10px;
  }
  .page-item.active .page-link {
    background-color: #B70B6D;
    border-color: #B70B6D;
  }
  .page-link {
    color: #B70B6D;
  }
  .user-icon {
    margin-top: -8px;
  }
  .user {
    margin-left: 10px;
  }
  .table-romeflex {
    font-size: 14px;
  }
  .table-striped tbody tr:nth-of-type(odd) {
    background-color: rgba(0, 0, 0, 0);
  }
  .table-striped tbody tr:nth-of-type(even) {
    background-color:#faeedf;
  }
  .btn-secondary:hover {
    color: #fff;
    background-color: #f7ac51;
    border-color: #f7ac51;
  }
  .orange-class {
    background-color: #F49A5B !important;
  }
  .blue-class {
    background-color: #007FC6 !important;
  }
  .grey-class {
    background-color: #d4d8dc !important;
  }
  .readonly-disabled {
    background-color: #e9ecef; /* Colore grigio chiaro */
    color: #6c757d; /* Colore testo grigio */
    padding: 0.375rem 0.75rem; /* Stile simile a <b-input-group-text> */
    border: 1px solid #ced4da; /* Bordo simile a <b-input-group-text> */
    border-radius: 0.25rem; /* Bordo arrotondato */
    display: flex;
    align-items: center;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue